var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.fields),function(field){return _c('component-renderer',{key:field.id,attrs:{"field":field}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }